import { Link } from 'react-router-dom'
import Modal from '../../../core/components/UI/Modal'
import { MdAdd, MdEdit, MdLink, MdPlusOne } from 'react-icons/md'

export default function ModalOpportunitiesOptions({
  isOpen,
  onClose,
  country,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`min-w-[512px] border-2 border-muted-500 bg-white`}
    >
      <ul className="flex flex-col gap-1 p-2">
        <li>
          <Link
            to={`/countries/${country.id}/opportunities/create`}
            className="flex items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300"
          >
            <MdAdd size={18} />
            <div>إضافة فرصة</div>
          </Link>
        </li>
        <li>
          <Link
            to={`/countries/${country.id}/opportunities/source`}
            className="flex items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300"
          >
            <MdLink
              className="rotate-45"
              size={18}
            />
            <div>المصدر</div>
          </Link>
        </li>
      </ul>
    </Modal>
  )
}
